export const KpiCard = ({ icon: Icon, label, value, sub, accent = "red", testId }) => {
  const accents = {
    red: "bg-honda-red-light text-honda-red",
    blue: "bg-blue-100 text-blue-600",
    green: "bg-green-100 text-green-600",
    orange: "bg-orange-100 text-orange-600",
  };
  return (
    <div
      data-testid={testId}
      className="honda-card p-3.5 flex flex-col gap-2 transition-shadow hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${accents[accent]}`}>
          <Icon size={18} strokeWidth={2.2} />
        </div>
        {sub && (
          <span className="text-[10px] uppercase tracking-wider font-semibold text-honda-subtle">
            {sub}
          </span>
        )}
      </div>
      <div>
        <p className="font-heading font-extrabold text-2xl text-honda-ink leading-none">
          {value}
        </p>
        <p className="text-[11px] text-honda-muted mt-1.5 leading-tight">{label}</p>
      </div>
    </div>
  );
};
